export default {"src":"/_next/static/media/icon-social-facebook-white.bf013e40.svg","height":23,"width":23};